import { css } from 'styled-components';
export const BKJThemeHorizontalRule = {
    Thick: css `
    height: 1px;
    min-height: 1px;
    max-height: 1px;
    background-color: ${({ theme }) => theme.colors.GreyDivider};
  `,
    Thin: css `
    height: 0.5px;
    min-height: 0.5px;
    max-height: 0.5px;
    background-color: ${({ theme }) => theme.colors.GreyDivider};
  `,
};
//# sourceMappingURL=BKJHorizontalRule.types.js.map